import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';

import { markFaxesAsRead } from 'api/Fax';

import DocumentModal from 'components/shared/DocumentEditor/DocumentModal';

const DocumentFaxModal = ({ item = {}, isOpen, handleClose }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!item?.read && item?.direction === 'inbound') {
      const onSuccess = () => {
        queryClient.invalidateQueries(['inboundFaxes']);
        queryClient.invalidateQueries(['unreadFaxes']);
      };

      markFaxesAsRead(navigate, [item?.id], onSuccess);
    }
  }, [item]);

  return (
    <DocumentModal
      kind="fax"
      id={item?.id}
      handleOpen={!!isOpen}
      handleClose={handleClose}
      isEditable
      title={'Fax #' + item?.id}
    />
  );
};

export default DocumentFaxModal;
